const initialState = {
	modal: null
};

const modal = ( state = initialState, action ) => {
	// must return the same state or an updated version of the state
	const actionLookup = {
    'MODAL_SET': () => ({...state, modal: action.modal}),
  };
  return actionLookup[action.type] ? actionLookup[action.type](state, action) : {...state}; // if the action type exists, execute action, otherwise returns default state
};

export default modal;


// WEBPACK FOOTER //
// ./src/store/reducers/modal.js